import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import NavBar from "../../components/Navbarr";
import SideBarAdmin from "../../components/SideBarAdmin";
import Footerr from "../../components/Footerr";
import AccessDenied from "../../components/AccessDenied";
import { UserContext } from "../../components/context/userContext";
import Modal from "react-modal";
import { toast } from "react-toastify";

import { getProducts } from "../../services/get-all-products";
import ModalProduct from "../../components/ModalProduct";
import ModalAddProductPhoto from "../../components/ModalAddProductPhoto";
import { addKmayraProduct } from "../../services/post-add-product";
import addProductPhotos from "../../services/post-add-product-photos";
import { Formik } from "formik";
import { getBySearch } from "../../services/get-search-product";
import { getByPagination } from "../../services/get-by-search";
import { useNavigate } from "react-router-dom";
import { updateProduct } from "../../services/put-product";
import updateProductPhotos from "../../services/put-product-photos";
import { api } from "../../config/baseApi";
import Lottie from "react-lottie";
import {
  defaultOptionsLoading,
  defaultloadImage,
} from "../../assets/lottie-animations/animationOptions";
import { deleteProductWithPhotos } from "../../services/delete-product-with-photos";
import ModalViderBasket from "../../components/ModalViderBasket";
import ProductImage from "../../components/ProductImage";
import ProductAdmin from "../../components/ProductAdmin/ProductAdmin";
interface initialImageStateType {
  selectedImage: Blob | MediaSource;
  imageUrl: string;
}

const initialImageState: initialImageStateType = {
  selectedImage: null,
  imageUrl: null,
};
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "100vh",
    // minHeight: "100vh",
    borderWidth: 0,
    borderRadius: 12,
    zIndex: 9,
    background: "transparent",
  },
};
const customStylesDelete = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "50vh",
    // minHeight: "100vh",
    borderWidth: 0.2,
    borderRadius: 12,
    zIndex: 9,

    background: "#fff",
  },
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

interface ProductsValue {
  name: string;
  description: string;
  quantity: number;
  sold: number;
  price: number;
  subCategory: string;
}

function Products() {
  const { user } = useContext(UserContext);
  const { width } = useWindowDimensions();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState("first");
  const [listProducts, setListProducts] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [limit, setLimit] = useState(6);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prodToDelete, setProdToDelete] = useState<any>(null);
  const [selectedOption, setSelectedOption] = useState({
    label: "",
    value: "",
  });
  const [images, setImages] = useState<any>([
    { ...initialImageState },
    { ...initialImageState },
    { ...initialImageState },
    { ...initialImageState },
    { ...initialImageState },
  ]);
  const [editMode, setEditMode] = useState(false);

  const [productsValues, setProductsValues] = useState<any>({
    name: "",
    description: "",
    quantity: 0,
    sold: 0,
    price: 0,
    subCategory: null,
  });

  function openModal() {
    setEditMode(false);
    setIsOpen(true);
  }
  function closeModal() {
    setSelectedOption({ label: "", value: "" });
    setIsOpen(false);
    setProductsValues({
      name: "",
      description: "",
      quantity: 0,
      sold: 0,
      price: 0,
      subCategory: null,
    });
    setImages([
      { ...initialImageState },
      { ...initialImageState },
      { ...initialImageState },
      { ...initialImageState },
      { ...initialImageState },
    ]);
    setStep("first");
  }

  const finishAddSuccess = () => {
    setLoadingAdd(false);
    closeModal();
    toast.success("Produit ajouté avec succès !");
    setPage(1);
    doGetInitialeListProducts(1, 6);
  };

  const doAddProductPhotos = (productId: any, files?: File[]) => {
    if (!productId) {
      setLoadingAdd(false);
      toast.error("Produit créé mais identifiant introuvable.");
      return;
    }

    // No photos selected → product is still created, just wrap up.
    if (!files || files.length === 0) {
      finishAddSuccess();
      return;
    }

    setLoadingAdd(true);

    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`photo${index + 1}`, file);
    });

    addProductPhotos(productId, formData)
      .then((response: any) => {
        if (!response?.data?.success) {
          setLoadingAdd(false);
          toast.error(
            response?.data?.message ||
              "Produit créé, mais l'envoi des photos a échoué.",
          );
          return;
        }
        finishAddSuccess();
      })
      .catch(() => {
        setLoadingAdd(false);
        toast.error("Produit créé, mais erreur lors de l'envoi des photos.");
      });
  };

  const doUpdateProductPhotos = (
    productId: any,
    deletedImageIds?: string[],
    newImages?: File[],
  ) => {
    if (
      (!deletedImageIds || deletedImageIds.length === 0) &&
      (!newImages || newImages.length === 0)
    ) {
      toast.success("Product updated successfully!");
      closeModal();
      doGetInitialeListProducts(1, 6);
      return;
    }

    setLoadingAdd(true);

    const formData = new FormData();

    // ✅ Append deleted IDs properly
    if (deletedImageIds && deletedImageIds.length > 0) {
      formData.append("deletedImageIds", JSON.stringify(deletedImageIds));
    }

    // ✅ Append new images properly
    if (newImages && newImages.length > 0) {
      newImages.forEach((file, index) => {
        formData.append(`photo${index + 1}`, file);
      });
    }

    updateProductPhotos(productId, formData)
      .then((response: any) => {
        setLoadingAdd(false);

        if (!response?.data?.success) {
          toast.error(response?.data?.message || "Update failed");
          return;
        }

        toast.success("Photos updated successfully!");
        closeModal();
        doGetInitialeListProducts(1, 6);
      })
      .catch(() => {
        setLoadingAdd(false);
        toast.error("Update error");
      });
  };

  const addProductValues = (newImages?: File[]) => {
    setLoadingAdd(true);
    let newProductValues = { ...productsValues };

    newProductValues.subCategory = selectedOption?.value;

    addKmayraProduct(newProductValues)
      .then((response) => {
        if (response?.status === 500) {
          setLoadingAdd(false);
          toast.error("Erreur interne du serveur !");
          return;
        }

        if (!response?.success) {
          setLoadingAdd(false);
          toast.error(response?.message);
          return;
        }

        // Product created — photos are the optional last step.
        doAddProductPhotos(response?.content?.product?._id, newImages);
      })
      .catch(() => {
        setLoadingAdd(false);
        toast.error("Une erreur est survenue lors de la création du produit.");
      });
  };

  const updateProductValues = (slots?: any) => {
    setLoadingAdd(true);
    updateProduct(productsValues?._id, productsValues)
      .then((response) => {
        if (response?.status === 500) {
          setLoadingAdd(false);
          toast.error("Internal Server Error !");
          return;
        }

        if (!response?.success) {
          setLoadingAdd(false);
          toast.error(response?.message);
          return;
        }

        // ✅ Only update photos if slots exist

if (slots) {
  const { deletedImageIds = [], newImages = [] } = slots;

  doUpdateProductPhotos(
    productsValues?._id,
    deletedImageIds,
    newImages
  );
}
 else {
          setLoadingAdd(false);
          toast.success("Product updated successfully!");
          closeModal();
          doGetInitialeListProducts(1, 6);
        }
      })
      .catch(() => {
        setLoadingAdd(false);
        toast.error("Update error");
      });
  };

  const SubmitProduct = (payload: any) => {
    if (editMode) {
      updateProductValues(payload);
    } else {
      addProductValues(payload?.newImages);
    }
  };

  const doGetProductsByPagination = (page: any, limit: any) => {
    setLoading(true);
    getByPagination(page, limit)
      .then((response) => {
        setLoading(false);

        if (!response.success) {
          toast.error(response.message);
          return;
        }
        if (response?.success) {
          setListProducts([...listProducts, ...response.content.products]);
          setTotalPages(response.content.totalPages);
          setCurrentPage(response.content.currentPage);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  const doGetInitialeListProducts = (page: any, limit: any) => {
    setLoading(true);
    getByPagination(page, limit)
      .then((response) => {
        setLoading(false);

        if (!response.success) {
          toast.error(response.message);
          return;
        }
        if (response?.success) {
          setListProducts(response.content.products);
          setTotalPages(response.content.totalPages);
          setCurrentPage(response.content.currentPage);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  const loadMoreAction = () => {
    let newPage = page + 1;
    setPage(newPage);
    doGetProductsByPagination(newPage, 6);
  };

  const doGetSearchedProducts = () => {
    if (!Boolean(searchQuery)) {
      return;
    } else {
      setLoading(true);
      getBySearch(searchQuery)
        .then((response) => {
          setLoading(false);

          if (response.status === 500) {
            toast.error("internal server error");
            return;
          }
          if (!response.success) {
            toast.error(response.message);
            return;
          }
          if (response.success) {
            setListProducts(response.content.products);
          }
        })
        .catch((error) => {
          setLoading(false);

          toast.error(error);
        });
    }
  };

  const openEditMode = (prod) => {
    setProductsValues(prod);
    setSelectedOption({
      label: prod?.subCategory?.name,
      value: prod?.subCategory?._id,
    });
    setEditMode(true);
    setIsOpen(true);
  };

  const handleDelete = () => {
    deleteProductWithPhotos(prodToDelete)
      .then((response) => {
        if (response.status === 500) {
          toast.error("internal server error");
          return;
        }
        if (!response.success) {
          toast.error(response.message);
          return;
        }
        if (response.success) {
          toast.success("Product deleted successfuly !");
          closeDeleteModal();
          setLimit(6);
          setPage(1);
          doGetInitialeListProducts(1, 6);
        }
      })
      .catch((error) => {
        toast.error("error", error);
      });
  };

  const openDelete = (id: any) => {
    setProdToDelete(id);
    setIsOpenDelete(true);
  };

  useEffect(() => {
    if (!Boolean(searchQuery)) {
      setLimit(6);
      setPage(1);
      doGetProductsByPagination(1, 6);
    } else if (searchQuery?.length > 3) {
      doGetSearchedProducts();
    }
  }, [searchQuery]);
  const closeDeleteModal = () => {
    setIsOpenDelete(false);
  };

  return (
    <>
      {user?.role == 1 ? (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <div className="side-bar-container">
              <SideBarAdmin widthWindow={width} screen={"products"} />
            </div>
            <div className="body-container">
              <div className="header-body">
                <div className="header-left">
                  <h3>Products</h3>
                  <button className="add-categorie-btn" onClick={openModal}>
                    Ajouter <i className="bx bx-plus"></i>
                  </button>
                </div>

                <Formik
                  initialValues={{ query: "" }}
                  onSubmit={(values, { setSubmitting }) => {
                    doGetSearchedProducts();
                    setTimeout(() => setSubmitting(false), 400);
                  }}
                >
                  {({ values, handleChange, handleBlur, handleSubmit }) => (
                    <form className="search-form" onSubmit={handleSubmit}>
                      <div className="search-bar-container">
                        <input
                          value={values.query}
                          className="search-bar"
                          onChange={(e) => {
                            handleChange(e);
                            setSearchQuery(e.target.value);
                          }}
                          onBlur={handleBlur}
                          name="query"
                          type="text"
                          placeholder="Search products..."
                        />
                        <button type="submit">
                          <i className="bx bx-search"></i>
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>

              <div className="line" />
              {loading ? (
                <div className="admin-loader">
                  <Lottie
                    options={defaultOptionsLoading}
                    height={150}
                    width={150}
                  />
                </div>
              ) : (
                <div className="boxes-container-p">
                  {listProducts?.length > 0 ? (
                    listProducts?.map((prod, index) => (
                      <ProductAdmin
                        key={prod._id}
                        product={prod}
                        onEdit={openEditMode}
                        onDelete={openDelete}
                      />
                    ))
                  ) : (
                    <div className="boxes-empty">No products found</div>
                  )}
                </div>
              )}
              <div className="load-more-row">
                {totalPages === currentPage ||
                searchQuery ||
                loading ||
                listProducts?.length <= 0 ? null : (
                  <button
                    className="load-more-btn"
                    onClick={() => loadMoreAction()}
                  >
                    Load more
                    <i className="bx bx-revision"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      ) : (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <AccessDenied />
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        {step == "first" ? (
          <ModalProduct
            setStep={setStep}
            productsValues={productsValues}
            setProductsValues={setProductsValues}
            editMode={editMode}
            closeModal={closeModal}
            step={step}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        ) : (
          <ModalAddProductPhoto
            setStep={setStep}
            SubmitProduct={SubmitProduct}
            editMode={editMode}
            productsValues={productsValues}
            closeModal={closeModal}
            loadingAdd={loadingAdd}
          />
        )}
      </Modal>
      <Modal
        isOpen={isOpenDelete}
        onRequestClose={closeDeleteModal}
        style={customStylesDelete}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalViderBasket
          action={handleDelete}
          closeModal={closeDeleteModal}
          text={"Are you sure to delete this product ?"}
        />
      </Modal>
    </>
  );
}

export default Products;
